import React, { useState } from 'react';
import Locales from 'locales';
import { renderCGUContent } from 'helpers';
import { ChevronRight } from 'lucide-react';

const LegalMention = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleBlock = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-hajj-muted via-white to-green-50 flex items-start justify-center">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-hajj-primary/5 rounded-full blur-3xl animate-pulse" />
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-green-200/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}
        />
      </div>

      <div className="relative w-full max-w-3xl animate-scale-in space-y-6 p-[50px]">
        {/* Page Header */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 tracking-tight mb-2">{Locales.legal.title}</h1>
          <p className="text-gray-600 text-base">{Locales.legal.description}</p>
        </div>

        {/* Legal Navigation */}
        <nav className="space-y-4">
          <ol className="space-y-2 divide-y divide-gray-300">
            {Locales.legal.articles.map((article) => (
              <li key={article.id} className="pt-2">
                <button
                  type="button"
                  onClick={() => toggleBlock(article.id)}
                  className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-900 hover:text-hajj-primary transition-colors py-2"
                >
                  <span>{article.title}</span>
                  <ChevronRight
                    className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
                      openIndex === article.id ? 'rotate-90' : 'rotate-0'
                    }`}
                  />
                </button>
                {openIndex === article.id && (
                  <section className="mt-2 bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg transition-all duration-300">
                    {article.preamble && <p className="mb-3">{article.preamble}</p>}
                    {renderCGUContent(article.content, `article-${article.id}`)}
                  </section>
                )}
              </li>
            ))}

            {/* Terms of Service */}
            <li className="pt-2">
              <button
                type="button"
                onClick={() => toggleBlock(Locales.legal.tos.id)}
                className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-900 hover:text-hajj-primary transition-colors py-2"
              >
                <span>{Locales.legal.tos.title}</span>
                <ChevronRight
                  className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
                    openIndex === Locales.legal.tos.id ? 'rotate-90' : 'rotate-0'
                  }`}
                />
              </button>
              {openIndex === Locales.legal.tos.id && (
                <section className="mt-2 bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg transition-all duration-300 space-y-4">
                  {Object.keys(Locales.legal.tos.sections).map((key) => {
                    const section = Locales.legal.tos.sections[key];
                    return (
                      <div key={`tos-${key}`}>
                        <h3 className="font-semibold text-gray-900 mb-2">{section.title}</h3>
                        {renderCGUContent(section.content, `tos-${key}`)}
                      </div>
                    );
                  })}
                </section>
              )}
            </li>

            {/* Confidentiality */}
            <li className="pt-2">
              <button
                type="button"
                onClick={() => toggleBlock(Locales.legal.confidentiality.id)}
                className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-900 hover:text-hajj-primary transition-colors py-2"
              >
                <span>{Locales.legal.confidentiality.title}</span>
                <ChevronRight
                  className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
                    openIndex === Locales.legal.confidentiality.id ? 'rotate-90' : 'rotate-0'
                  }`}
                />
              </button>
              {openIndex === Locales.legal.confidentiality.id && (
                <section className="mt-2 bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg transition-all duration-300 space-y-4">
                  {Object.keys(Locales.legal.confidentiality.sections).map((key) => {
                    const section = Locales.legal.confidentiality.sections[key];
                    return (
                      <div key={`conf-${key}`}>
                        {section.title && <h3 className="font-semibold text-gray-900 mb-2">{section.title}</h3>}
                        {renderCGUContent(section.content, `conf-${key}`)}
                      </div>
                    );
                  })}
                </section>
              )}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default LegalMention;
